import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLanguage } from '@fortawesome/free-solid-svg-icons';

const LangSelector = ({ color = 'white', userId = null }) => {
  const { i18n } = useTranslation();
  const languages = [
    {
      code: 'en',
      name: 'English',
    },
    {
      code: 'es',
      name: 'Español',
    },
  ];

  const isSelectedLang = (lang) => lang === i18n.language;

  const handleLangChange = (lang) => {
    i18n.changeLanguage(lang);
    // Set the i18nextLangManual localStorage
    // This can be used to identify that the user has manually changed the language,
    // and prevent auto-changing it again on game entry
    localStorage.setItem('i18nextSetBy', userId || 'unknown');
  };

  return (
    <div
      className={`d-flex justify-content-center align-items-center text-${color}`}
      style={{ padding: '20px' }}>
      <FontAwesomeIcon icon={faLanguage} size='1x' className='icon me-2' />

      {languages?.map((l) => (
        <button
          key={l.code}
          onClick={() => handleLangChange(l.code)}
          className={`btn btn-link text-decoration-none text-${color} ${
            isSelectedLang(l.code)
              ? 'font-weight-bold fw-bold text-decoration-underline'
              : 'opacity-75'
          }`}>
          {l.name}
        </button>
      ))}
    </div>
  );
};

export default LangSelector;
